export const scrollToView = (element) => {
  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const middlePoint = absoluteElementTop - window.innerHeight / 2;
  window.scrollTo({
    top: middlePoint,
    behavior: "smooth",
  });
};
